import React, { Component } from 'react';
import './App.css';

class App extends Component {

  render() {
    return (
      <div className="container-fluid d-flex flex-column justify-content-center text-center">
        <h1 className="display-2">Paul Thomas</h1>
        <h3 className="subtitle">Software Engineer</h3>
        <br />
        <div>
          <a href="https://github.com/paulfthomas">
            <img className="logo" src="images/github.svg" alt="GitHub profile" />
          </a>
          ||
          <a href="https://www.linkedin.com/in/paulfthomas">
            <img className="logo" src="images/linked-in.svg" alt="LinkedIn profile" />
          </a>
          ||
          <a href="mailto:me@paulfthomas.com">
            <img className="logo" src="images/gmail.svg" alt="Email" />
          </a>
          ||
          <a href="https://drive.google.com/file/d/1-_SvT3TndkbVyV5SXdGVd0QlK5EgSbVt/view?usp=sharing">
            <img className="logo" src="images/gdrive.svg" alt="Resume" />
          </a>
        </div>
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js